import type { CampaignProductsParams } from '~/api/data-source/campaign';
import { campaignRepository } from '~/api/repository/campaign';

export const CAMPAIGN_QUERY_KEY = {
  all: ['campaign'] as const,

  // 오늘 타겟팅된 캠페인 상품 목록 (마켓알뜰톡톡)
  todayProducts: (params: CampaignProductsParams) => ({
    queryKey: ['/api/market-place/v1/campaigns/products', params] as const,
    queryFn: () => campaignRepository.getTodayCampaignProducts(params),
  }),
};
